<f-divider color="neutral-mountain-mist" />
<nav class="p-l">
  <ul class="navigation flex flex-row justify-center start gap-3xl align-center align-items-center">
    @if(isAdmin()) {
    <li>
      <a routerLink="/admin/global-features" routerLinkActive="active" ariaCurrentWhenActive="page">Global
        Features</a>
    </li>
    <li>
      <a routerLink="/admin/client-features" routerLinkActive="active" ariaCurrentWhenActive="page">Client
        Features</a>
    </li>
    <li>
      <a routerLink="/admin/manage-content" routerLinkActive="active" ariaCurrentWhenActive="page">Manage Content</a>
    </li>
    <li>
      <a routerLink="/admin/manage-help" routerLinkActive="active" ariaCurrentWhenActive="page">Manage Help</a>
    </li>
    } @else {
    <!-- Internal users navigation -->
    @if(isInternalUser()) {
    <!-- <li><a routerLink="/internal" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page">Home</a></li> -->
    <!-- @if(isReportsAndDashboardsEnabled()) { -->
    <li><a routerLink="/internal/reports-and-dashboards" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page">Reports &
        Dashboards</a></li>
    <!-- } -->
    @if(isSubscriptionsEnabled()) {
    <li><a routerLink="/internal/subscriptions" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page">Subscriptions</a></li>
    }
    @if(isHelpEnabled()) {
    <li><a routerLink="/internal/help" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page">Help</a></li>
    }
    } @else {
    <!-- External users navigation -->
    <!-- @if(isReportsAndDashboardsEnabled()) { -->
    <li><a routerLink="/reports-and-dashboards" routerLinkActive="active" ariaCurrentWhenActive="page">Reports &
        Dashboards</a></li>
    <!-- } -->
  <!-- Show Subscriptions link whenever feature flag enabled (Leaves persona no longer required) -->
    <!--@if(hasLeavesAccess() && isSubscriptionsEnabled()) { -->
    @if(isSubscriptionsEnabled()) {
    <li><a routerLink="/subscriptions" routerLinkActive="active" ariaCurrentWhenActive="page">Subscriptions</a></li>
    }
    <!-- Only show Help link if Help category has at least one enabled feature -->
    @if(isHelpEnabled()) {
    <li><a routerLink="/help" routerLinkActive="active" ariaCurrentWhenActive="page">Help</a></li>
    }
    @if(showAIButton && isAIChatEnabled()) {
    <li>
      <f-button class="ai-button" text="Ask about reports" size="small" variant="action"
        icon-config='{"iconName": "sparkles", "iconType": "solid", "iconPlacement": "left"}'
        (buttonClicked)="onButtonClicked($event)">
      </f-button>
    </li>
    }
    }
    @if(isInDevEnvironment && isAdminUser()) {
    <li>
      <a routerLink="/admin" routerLinkActive="active" ariaCurrentWhenActive="page">Admin [Dev]</a>
    </li>
    }
    @if(!isInDevEnvironment && isAdminUser()) {
    <li>
      <a routerLink="/admin" routerLinkActive="active" ariaCurrentWhenActive="page">Admin</a>
    </li>
    }
    }
  </ul>
</nav>
<f-divider color="neutral-mountain-mist" />